import { Injectable } from '@angular/core';

@Injectable()
export class UiHelperService {

  public scrollToElement = function (selector: any): void {
    const element = typeof selector === 'string'
      ? document.getElementById(selector)
      : selector;

    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };
}
